<div class="app-header">
  <div class="left-section"></div>
  <div class="right-section">
    <!-- <nz-badge [nzCount]="notificationCount" [nzOverflowCount]="99">
      <span class="notification-trigger">
        <i nz-icon nzType="bell" nzTheme="outline"></i>
      </span>
    </nz-badge>
    <nz-avatar [nzSize]="32" nzIcon="user"></nz-avatar>
    <a
      nz-dropdown
      [nzDropdownMenu]="menu"
      nzTrigger="click"
      nzPlacement="bottomRight"
    >
      <span>Admin</span>
      <i nz-icon nzType="down"></i>
    </a>
    <nz-dropdown-menu #menu="nzDropdownMenu">
      <ul nz-menu>
        <li nz-menu-item>
          <i nz-icon nzType="user" nzTheme="outline"></i>
          <span>Profile</span>
        </li>
        <li nz-menu-item>
          <i nz-icon nzType="setting" nzTheme="outline"></i>
          <span>Settings</span>
        </li>
        <li nz-menu-divider></li>
        <li nz-menu-item>
          <a routerLink="/logout">
            <i nz-icon nzType="logout" nzTheme="outline"></i>
            <span>Logout</span>
          </a>
        </li>
      </ul>
    </nz-dropdown-menu> -->
  </div>
</div>
